import { render, staticRenderFns } from "./header-errors.vue?vue&type=template&id=95a905c8&scoped=true"
import script from "./header-errors.vue?vue&type=script&lang=js"
export * from "./header-errors.vue?vue&type=script&lang=js"
import style0 from "./header-errors.vue?vue&type=style&index=0&id=95a905c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a905c8",
  null
  
)

export default component.exports